const EXAM_ID_LABEL_PATTERN = /\bexam[\s_-]*id\b[:#\s-]*([a-z0-9._-]+)/i;
const STARTDATE_PREFIX_PATTERN =
  /^start\s*date[:\s-]*\d{1,2}[-./][a-z]{3,9}[-./]\d{2,4}\s*/i;
const DATE_PREFIX_PATTERN = /^\d{1,2}[-./][a-z]{3,9}[-./]\d{2,4}\s*/i;
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const GENERIC_TOKENS = new Set([
  "startdate",
  "start",
  "date",
  "recording",
  "eeg",
  "edf",
  "bdf",
  "nihon",
  "kohden",
  "equipment",
  "device",
]);

function normalizeWhitespace(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

function sanitizeFilenameBase(fileName: string): string {
  const withoutExt = fileName.replace(/\.[^/.]+$/, "");
  return withoutExt.replace(/^\d{10,}-/, "");
}

function pickExamCandidate(raw: string): string | null {
  const explicit = raw.match(EXAM_ID_LABEL_PATTERN)?.[1];
  if (explicit) return explicit.trim();

  const cleaned = normalizeWhitespace(
    raw.replace(STARTDATE_PREFIX_PATTERN, "").replace(DATE_PREFIX_PATTERN, ""),
  );
  if (!cleaned) return null;

  const tokens = cleaned
    .split(/[\s,;|/\\]+/)
    .map((token) => token.trim())
    .filter(Boolean);

  const usefulToken = tokens.find((token) => {
    const normalized = token.toLowerCase().replace(/[^a-z0-9]+/g, "");
    if (!normalized) return false;
    if (GENERIC_TOKENS.has(normalized)) return false;
    return true;
  });

  return usefulToken || cleaned;
}

export function extractCleanExamId(
  recordingIdFromEdf?: string | null,
  fallbackFileName?: string | null,
): string {
  const raw = normalizeWhitespace(recordingIdFromEdf || "");
  if (raw) {
    const candidate = pickExamCandidate(raw);
    if (candidate && !UUID_PATTERN.test(candidate)) {
      return candidate.slice(0, 80);
    }
  }

  if (fallbackFileName) {
    return sanitizeFilenameBase(fallbackFileName).slice(0, 80);
  }

  return "Unknown Exam";
}

